import { createValidator } from 'revalidate';
import { INVALID_PHONE_NUMBER } from '../constants/defaultErrorMessages';
const isValidPhoneNumber = createValidator(message => value => {
  if (value && !/^\d{1,20}$/.test(value)) {
    return message || INVALID_PHONE_NUMBER;
  }
  return null;
}, INVALID_PHONE_NUMBER);
export default isValidPhoneNumber;
//# sourceMappingURL=isValidPhoneNumber.js.map